import { lazy } from "react";
import {
  DatabaseOutlined,
  UnlockOutlined,
  TeamOutlined,
  SafetyCertificateOutlined,
  DownloadOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  HomeOutlined,
  GoldOutlined,
  ProductOutlined,
  FileTextOutlined,
  BankOutlined,
  FileDoneOutlined,
  FileProtectOutlined,
  InsertRowBelowOutlined,
  ReconciliationOutlined,
  CalculatorOutlined,
  DiffOutlined,
  LayoutOutlined,
} from "@ant-design/icons";
import { CiMonitor } from "react-icons/ci";
import Users from "../pages/auth/MasterData/Users";
import Privilege from "../pages/auth/MasterData/Privilege";
import AccessControlList from "../pages/auth/MasterData/AccessControlList";
import CommingSoon from "../pages/other/coming_soon";
import Inbound from "../pages/auth/Inbound";
import Outbound from "../pages/auth/Outbound";
import DeviceSensor from "../pages/auth/MasterData/DeviceSensor";
import Warehouse from "../pages/auth/MasterData/Warehouse";
import Pallet from "../pages/auth/MasterData/Pallet";
import Product from "../pages/auth/MasterData/Product";
import RequestInbound from "../pages/auth/RequestInbound";
import RequestOutbound from "../pages/auth/RequestOutbound";
import Reports from "../pages/auth/Reports";
import Area from "../pages/auth/MasterData/Area";
import ProductType from "../pages/auth/MasterData/ProductType";
import ProductCost from "../pages/auth/MasterData/ProductCost";
import Invoice from "../pages/auth/Invoice";
import Rules from "../pages/auth/Rules";
import StockOpname from "../pages/auth/StockOpname";
import StockOverview from "../pages/auth/StockOverview";
import Calculator from "../pages/noauth/Calculator";
import { Navigate } from "react-router";
import { Link } from "react-router-dom";
import MaterialHandling from "../pages/auth/MasterData/MaterialHandling";
import LayoutColdStorage from "../pages/auth/LayoutColdStorage";

// Pages
const Dashboard = lazy(() => import("../pages/auth/Dashboard"));

export const MENU_LIST = [
  {
    name: "Dashboard",
    code: "Dashboard",
    icon: <CiMonitor />,
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    name: "Inbound",
    code: "Inbound",
    icon: <DownloadOutlined />,
    path: "/inbound",
    element: <Inbound />,
  },
  {
    name: "Outbound",
    code: "Outbound",
    icon: <UploadOutlined />,
    path: "/outbound",
    element: <Outbound />,
  },
  {
    name: "Transaction",
    code: "Transaction",
    icon: <FileTextOutlined />,
    path: "/transaction",
    element: <Invoice />,
  },
  {
    name: "Reports",
    code: "Report",
    icon: <FileDoneOutlined />,
    path: "/reports",
    element: <Reports />,
  },
  {
    name: "Stock Opname",
    code: "Stock Opname",
    icon: <InsertRowBelowOutlined />,
    path: "/stock-opname",
    element: <StockOpname />,
  },
  {
    name: "Stock Overview",
    code: "Stock Overview",
    icon: <ReconciliationOutlined />,
    path: "/stock-overview",
    element: <StockOverview />,
  },
  {
    name: "Policy & Price List",
    code: "Policy & Price List",
    icon: <FileProtectOutlined />,
    path: "/policy",
    element: <Rules />,
  },
  {
    name: "Calculator Biaya Penyimpanan",
    code: "Calculator Biaya",
    icon: <CalculatorOutlined />,
    path: "/calculator",
    newTab: true,
  },
  {
    name: "Master Data",
    code: "Master Data",
    icon: <DatabaseOutlined />,
    children: [
      {
        name: "Users",
        code: "Users",
        icon: <TeamOutlined />,
        path: "/users",
        element: <Users />,
      },
      {
        name: "Privilege",
        code: "Privilege",
        icon: <UnlockOutlined />,
        path: "/privilege",
        element: <Privilege />,
      },
      {
        name: "Access Control List",
        code: "Access Control List",
        icon: <SafetyCertificateOutlined />,
        path: "/access-control-list",
        element: <AccessControlList />,
      },
      {
        name: "Warehouse",
        code: "Warehouse",
        icon: <HomeOutlined />,
        path: "/warehouse",
        element: <Warehouse />,
      },
      {
        name: "Area",
        code: "Area",
        icon: <BankOutlined />,
        path: "/area",
        element: <Area />,
      },
      {
        name: "RFID",
        code: "RFID",
        icon: <DeploymentUnitOutlined />,
        path: "/rfid",
        element: <DeviceSensor />,
      },
      {
        name: "Pallet",
        code: "Pallet",
        icon: <GoldOutlined />,
        path: "/pallet",
        element: <Pallet />,
      },
      {
        name: "Product Type",
        code: "Product Type",
        icon: <ProductOutlined />,
        path: "/product-type",
        element: <ProductType />,
      },
      {
        name: "Product Cost",
        code: "Product Cost",
        icon: <ProductOutlined />,
        path: "/product-cost",
        element: <ProductCost />,
      },
      {
        name: "Product",
        code: "Product",
        icon: <ProductOutlined />,
        path: "/product",
        element: <Product />,
      },
      {
        name: "Material Handling",
        code: "Material Handling",
        icon: <DiffOutlined />,
        path: "/material-handling",
        element: <MaterialHandling />,
      },
    ],
  },
  // {
  //   name: "Layout Cold Storage",
  //   code: "Layout Cold Storage",
  //   icon: <LayoutOutlined />,
  //   path: "/layout-cold-storage",
  //   element: <LayoutColdStorage />,
  // },
];
